import { IngredientType } from '@libs/trip-planner-interfaces';
import type {
  IngredientId,
  SelectedTicketInfo,
} from '@libs/trip-planner-interfaces';

import { BaseIngredient } from './baseIngredient';

export class ActivityIngredient extends BaseIngredient<IngredientType.Activity> {
  public tickets: SelectedTicketInfo[] = [];

  // NOTE: YYYY-MM-DD format, only for fixed date activities
  public selectedTicketDate?: string;

  // NOTE: Offset is undefined for fixed date activities
  public offset: number | undefined = 0;

  constructor(
    public code: string,
    public parentIngredientId: IngredientId
  ) {
    super(IngredientType.Activity);
  }

  public isIngredientCorrect(): boolean {
    return true;
  }
}
